


















































import { Component } from 'vue-property-decorator';
import { PersonModule } from '@/store/Customers/PersonModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PersonDetails from '@/components/Customers/People/PersonDetails.vue';
import RelatedCustomers from '@/components/Customers/Customers/RelatedCustomers.vue';
import RelatedRecords from '@/components/Customers/Customers/RelatedRecords.vue';
import Addresses from '@/components/Customers/Customers/Addresses.vue';

@Component({ name: 'Person', components: { Alert, RelatedRecords, Addresses, PersonDetails, RelatedCustomers }, metaInfo: { title: 'People' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await PersonModule.getPerson(this.$route.params.id);
    }

    get person() {
        return PersonModule.person;
    }

    get loading() {
        return PersonModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
